var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowStrs1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 24,
    viewBox: "0 0 123 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3375_19250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6043 0.75769L14.2095 8.7757H22.6402L15.8196 13.7311L18.4249 21.7491L11.6043 16.7938L4.7838 21.7491L7.38901 13.7311L0.568481 8.7757H8.99911L11.6043 0.75769Z",
    fill: "#FE6A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5526 0.75769L39.2881 8.7757H48.1403L40.9786 13.7311L43.7141 21.7491L36.5526 16.7938L29.3911 21.7491L32.1266 13.7311L24.965 8.7757H33.8171L36.5526 0.75769Z",
    fill: "#FE6A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9198 0.75769L63.6553 8.7757H72.5074L65.3458 13.7311L68.0813 21.7491L60.9198 16.7938L53.7583 21.7491L56.4938 13.7311L49.3322 8.7757H58.1843L60.9198 0.75769Z",
    fill: "#FE6A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4471 0.75769L89.1826 8.7757H98.0348L90.8732 13.7311L93.6086 21.7491L86.4471 16.7938L79.2856 21.7491L82.0211 13.7311L74.8595 8.7757H83.7117L86.4471 0.75769Z",
    fill: "#FE6A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.395 0.75769L114.001 8.7757H122.432L115.611 13.7311L118.216 21.7491L111.395 16.7938L104.575 21.7491L107.18 13.7311L100.359 8.7757H108.79L111.395 0.75769Z",
    fill: "#FE6A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3375_19250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 23.2075,
    fill: "white",
    transform: "translate(0.00012207 0.75769)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStrs1);
export default __webpack_public_path__ + "static/media/yellow-strs 1.8435ac0de99e670d059f721f0cede128.svg";
export { ForwardRef as ReactComponent };